import React from "react";

export const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <label className="block">
    <span className="block text-xs uppercase tracking-wide text-secondary-500 mb-1">{label}</span>
    {children}
  </label>
);
